/** Names of cookies used in project */
enum CookieNames {
  /** used to identify when the last signin event occurred */
  lastSignIn = "lastSignIn",
  /** ID of the latest active token */
  activeTokenId = "activeTokenId"
}
export default CookieNames;
